export default {"src":"/_next/static/media/appStore.9bf80be0.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};